import * as React from 'react';
import type { ImageBackgroundCallToActionViewModel } from '../ImageBackgroundCallToActionViewModel.csharp';
import { asHtmlString } from '~/Partials/Controls/Utils/asHtmlString';
import { ImageBackgroundCallToAction } from '~/Partials/ImageBackgroundCallToAction/ImageBackgroundCallToAction';

export const ImageBackgroundCallToActionBlock: React.FC<
    React.PropsWithChildren<ImageBackgroundCallToActionViewModel>
> = props => {
    const { callToActionLink, heading, description, ...otherProps } = props;

    const descriptionProp = description ? asHtmlString(description) : undefined;

    return (
        <ImageBackgroundCallToAction
            {...otherProps}
            heading={asHtmlString(heading)}
            callToAction={{ ...callToActionLink, type: 'link' }}
            description={descriptionProp}
        />
    );
};
